/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobListResponse {
    getFixupPrototypeFunction() { return TemplateJobListResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobListResponse>): TemplateJobListResponse {
        let obj = Object.assign(new TemplateJobListResponse(), model);
        TemplateJobListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobListResponse>): TemplateJobListResponse {
        if (!model) return null;
        return TemplateJobListResponse.newInstance(<TemplateJobListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobListResponse) {
        if (!obj) return;

        models.TemplateJobListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobListResponse): boolean {
        Object.setPrototypeOf(obj, TemplateJobListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.jobs) {
            models.TemplateJobsList.fixupPrototype(this.jobs);
        }
    }

    jobs: models.TemplateJobsList;

}
